import { generateName } from '@runkr/config'

/** `adjective-animal-NN`, e.g. `sunny-otter-42`, from the shared word list (D-024). */
export function guestName(random: () => number = Math.random): string {
  return generateName(random)
}
